import { render } from "./SVIForm.vue?vue&type=template&id=678a3151"
import script from "./SVIForm.vue?vue&type=script&lang=js"
export * from "./SVIForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__